import React from 'react'

export const DATE_FORMAT = () => "MM/dd/yyyy"